import { advancedFlowSchema_ } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import * as z from "zod/v4";

export const getRulesByTrigger = {
  name: "getRulesByTrigger" as const,
  input: z.object({ triggerKey: z.string() }),
  output: z.object({
    rules: z.array(
      advancedFlowSchema_.pick({
        _id: true,
        name: true,
        enabled: true,
        index: true,
        steps: true,
      }),
    ),
  }),
};
